import { apiFetch } from '../../../common/api/apiFetchClient';
import type { StatusReportRecord } from '../reportFilters';

const BASE = '/api/rfi/reports';

export type DownloadSearchType = 'producerName' | 'agentName' | 'marketSegment' | 'salesOfficeName';

export interface DownloadParams {
  searchType: DownloadSearchType;
  searchValue: string;
  filterType?: string;
  filterValue?: string;
  includeInternalFields: 'true' | 'false';
}

export const reportsApi = {
  getByProducerName(producerName: string): Promise<{ records: StatusReportRecord[] }> {
    return apiFetch(`${BASE}/producerName?producerName=${encodeURIComponent(producerName)}`);
  },

  getByAgentName(agentName: string): Promise<{ records: StatusReportRecord[] }> {
    return apiFetch(`${BASE}/agentName?agentName=${encodeURIComponent(agentName)}`);
  },

  getByMarketSegmentFilter(
    marketSegment: string,
    filterType: string,
    filterValue: string,
  ): Promise<{ records: StatusReportRecord[] }> {
    const params = new URLSearchParams({ marketSegment, filterType, filterValue }).toString();
    return apiFetch(`${BASE}/marketSegment?${params}`);
  },

  getBySalesOfficeFilter(
    salesOffice: string,
    filterType: string,
    filterValue: string,
  ): Promise<{ records: StatusReportRecord[] }> {
    const params = new URLSearchParams({ salesOffice, filterType, filterValue }).toString();
    return apiFetch(`${BASE}/salesOffice?${params}`);
  },

  getMarketSegments(): Promise<{ marketSegments: string[] }> {
    return apiFetch(`${BASE}/marketSegments`);
  },

  async downloadReport(params: DownloadParams): Promise<Blob> {
    const query = new URLSearchParams(
      Object.fromEntries(
        Object.entries(params).filter(([, v]) => {return v !== undefined && v !== ''}),
      ) as Record<string, string>,
    ).toString();

    return apiFetch<Blob>(`${BASE}/download?${query}`, {
      responseType: 'blob',
    });
  },
};
